var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessageBubbleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 9.5a7.422 7.422 0 01-1.05 3.8c-.823 1.412-2.089 2.6-3.655 3.43-1.566.83-3.37 1.27-5.212 1.27a11.128 11.128 0 01-4.433-.9L1 19l2.217-5.7a7.421 7.421 0 01-1.05-3.8c0-1.578.514-3.125 1.482-4.467C4.618 3.69 6.003 2.606 7.65 1.9a11.128 11.128 0 014.433-.9h.584c2.431.115 4.728.995 6.45 2.47C20.84 4.948 21.866 6.917 22 9v.5z",
    stroke: "#242424",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgMessageBubbleIcon;